/**
 * Determine if provided address string is a post office box.
 * @param {string} address
 * @returns {boolean}
 */
export const isPoBox = (address) => (/^\s*((P(OST)?.?\s*O(FF(ICE)?)?.?\s+(B(IN|OX) )?)|B(IN|OX) )/i).test(address);
